export const DEFAULT_BAG_ITEM_IMAGES = [
  'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=48&q=80',
  'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=48&q=80',
  'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=48&q=80',
  'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=48&q=80',
];

export const SAVINGS_TITLE = 'Total Savings';
export const SAVINGS_DESC = 'You Saved';
export const SAVINGS_AMOUNT_SYMBOL = '₹';
export const SAVINGS_DESC_SUFFIX = 'Apply coupons & offers to your bag to save more';

// Default savings message - can be overridden by remote config (cartNudgeConfig.non_logged_in_savings or logged_in_savings)
export const NON_LOGGED_IN_SAVINGS = 'Apply coupons & offers to your bag to save more';

export const NEW_PRODUCT_TITLE = 'New item added';
export const VIEW_BAG_BUTTON_TEXT = 'View bag';
export const CLOSE_ICON_SIZE = '32px';

// Item count constants
export const SINGLE_ITEM_TEXT = 'more item';
export const MULTIPLE_ITEMS_TEXT = 'more items';
export const BAG_INFO_SUFFIX = 'in your bag';

// Image alt text constants
export const PRODUCT_IMAGE_ALT = 'Product';
export const BAG_ITEM_IMAGE_ALT_PREFIX = 'Bag item';

// Size display constants
export const SIZE_PREFIX = 'Size';

// Default values
export const DEFAULT_SAVINGS = 0;
export const FIRST_ITEM_INDEX = 0;
export const SECOND_ITEM_INDEX = 1;
export const DEFAULT_ASPECT_RATIO = 1;
export const PRODUCT_IMAGE_HEIGHT = 200;
export const BAG_ITEM_IMAGE_HEIGHT = 48;
export const MAX_BAG_ITEMS_TO_DISPLAY = 5;
